import { useState } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, Users, Sparkles, GraduationCap, Scale, Trees, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const VALUES = [
  { title: "Ascolto", desc: "Fermarsi, dare tempo, comprendere prima di agire." },
  { title: "Accoglienza", desc: "Ogni persona ha diritto a un posto in cui sentirsi vista." },
  { title: "Non giudizio", desc: "Riconosciamo le storie e le condizioni di ciascuno." },
  { title: "Partecipazione", desc: "Le cose migliori si costruiscono insieme, non si erogano." },
  { title: "Cura delle relazioni", desc: "Le relazioni sono infrastruttura, non ornamento." },
];

const FOUNDERS = [
  { img: "/persona-5.jpeg", name: "Gabriella Mazzanti", role: "Presidente", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-6.jpeg", name: "Elisa Rosso", role: "Vice Presidente", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-7.jpeg", name: "Silvia Santunione", role: "Consigliera", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-2.jpeg", name: "Silvia Luccoli", role: "Tesoriera", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-3.jpeg", name: "Stefania Gamberini", role: "Consigliera", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-4.jpeg", name: "Teresa Vilardo", role: "Consigliera", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa la lega a Vola Vola e su quali progetti è più attiva." },
  { img: "/persona-1.jpeg", name: "Lorenzo Stanzani", role: "Consigliere", bio: "Bio breve in arrivo. Racconta in 3-4 righe la storia della persona, cosa lo lega a Vola Vola e su quali progetti è più attivo." },
];

export default function ChiSiamo() {
  const [openIndex, setOpenIndex] = useState(null);
  const current = openIndex !== null ? FOUNDERS[openIndex] : null;
  return (
    <div data-testid="chi-siamo-page">
      <section id="vola" className="relative bg-[#FFF1E8] py-20 lg:py-28 overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 blob bg-[#FF6100]/15 -z-0" />
        <div className="container-vv relative">
          <div className="eyebrow">Chi siamo</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#292522] max-w-4xl">
            Una comunità che si <span className="text-[#FF6100]">prende cura</span> del territorio.
          </h1>
          <p className="mt-6 text-lg text-[#292522]/75 max-w-3xl leading-relaxed">
            Vola Vola APS è un'Associazione di Promozione Sociale con sede a Castel Maggiore (Bologna). Creiamo occasioni di incontro, confronto, crescita e partecipazione per famiglie, bambine, bambini e comunità. <span className="text-[#292522]/50 italic">(Descrizione da personalizzare)</span>
          </p>
        </div>
      </section>

      <section id="storia" className="container-vv py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="eyebrow">La nostra storia</div>
            <h2 className="mt-3 font-display text-4xl font-medium text-[#292522]">Nate dai bisogni, cresciute con le persone.</h2>
          </div>
          <div className="lg:col-span-8 prose prose-lg max-w-none text-[#292522]/80">
            <p className="text-lg leading-relaxed">
              <span className="bg-[#FFF1E8] px-1 rounded">CONTENUTO DEMO – DA SOSTITUIRE.</span> Racconta qui la storia di Vola Vola: come è nata, chi c'era, cosa si voleva far succedere sul territorio. Mantieni un tono personale, umano, evita retorica associativa.
            </p>
            <p className="text-lg leading-relaxed mt-4">
              Vola Vola è affiliata ad ARCI e iscritta al RUNTS <span className="text-[#292522]/50 italic">(dati da verificare)</span>. Non è un'impresa commerciale, non è un servizio rivolto esclusivamente alle madri e non si occupa solo di prima infanzia: è una realtà di comunità.
            </p>
          </div>
        </div>
      </section>

      <section id="come" className="bg-[#F8F1E8] py-20 lg:py-28">
        <div className="container-vv">
          <div className="max-w-2xl">
            <div className="eyebrow">Come lavoriamo</div>
            <h2 className="mt-3 font-display font-medium text-4xl sm:text-5xl text-[#292522]">Cinque parole per il nostro metodo.</h2>
          </div>
          <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {VALUES.map((v, i) => (
              <div key={v.title} className="card-vv p-8 bg-white" data-testid={`value-${i}`}>
                <div className="text-5xl font-display font-medium text-[#FF6100]/25">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-3 font-display text-2xl font-medium text-[#292522]">{v.title}</h3>
                <p className="mt-2 text-[#292522]/70">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="persone" className="container-vv py-20 lg:py-28">
        <div className="eyebrow">Soci fondatori</div>
        <h2 className="mt-3 font-display font-medium text-4xl sm:text-5xl text-[#292522]">Siamo in sette. Insieme.</h2>
        <p className="mt-4 text-lg text-[#292522]/70 max-w-2xl">
          Sette persone hanno fondato Vola Vola APS. Storie diverse, sguardi diversi, un desiderio comune: costruire un pezzo di comunità in cui prendersi cura sia una cosa condivisa, non un peso da portare da soli.
          <span className="block text-xs text-[#292522]/50 italic mt-2">Clicca su una foto per leggere la bio (bio in arrivo)</span>
        </p>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {FOUNDERS.map((p, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setOpenIndex(i)}
              className="text-left card-vv p-5 bg-white group hover:-translate-y-1 transition-transform duration-300 focus-visible:ring-2 focus-visible:ring-[#FF6100]"
              data-testid={`persona-${i}`}
              aria-label={`Leggi la bio di ${p.name}`}
            >
              <div className="relative mb-5 mx-auto w-40 h-40 sm:w-44 sm:h-44 rounded-full overflow-hidden bg-[#FFF1E8] ring-4 ring-[#FFF1E8] shadow-[0_8px_28px_rgba(41,37,34,0.10)]">
                <img src={p.img} alt={`Foto di ${p.name}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute inset-0 rounded-full ring-1 ring-inset ring-[#292522]/10" />
              </div>
              <h3 className="mt-2 text-center font-display text-lg font-medium group-hover:text-[#FF6100] transition-colors">{p.name}</h3>
              <p className="text-center text-sm text-[#292522]/60">{p.role}</p>
            </button>
          ))}
        </div>

        <Dialog open={openIndex !== null} onOpenChange={(o) => !o && setOpenIndex(null)}>
          <DialogContent className="max-w-3xl bg-[#FFFCF8] border-0 p-0 overflow-hidden rounded-3xl" data-testid="persona-dialog">
            {current && (
              <div className="grid md:grid-cols-5 gap-0">
                <div className="md:col-span-2 relative bg-[#FFF1E8] p-8 flex items-center justify-center">
                  <div className="relative w-48 h-48 sm:w-56 sm:h-56 rounded-full overflow-hidden ring-4 ring-white shadow-[0_10px_40px_rgba(41,37,34,0.15)]">
                    <img src={current.img} alt={current.name} className="absolute inset-0 w-full h-full object-cover object-top" />
                  </div>
                  <div className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-[10px] font-semibold text-[#FF6100] tracking-wider">SOCIO/A FONDATORE/A</div>
                </div>
                <div className="md:col-span-3 p-8 lg:p-10">
                  <DialogTitle className="font-display text-3xl font-medium text-[#292522]">{current.name}</DialogTitle>
                  <DialogDescription className="mt-1 text-[#FF6100] font-semibold">{current.role}</DialogDescription>
                  <div className="mt-6 text-[#292522]/80 leading-relaxed whitespace-pre-line">{current.bio}</div>
                  <div className="mt-8 pt-6 border-t border-[#292522]/8 text-xs text-[#292522]/50 italic">
                    Testo bio da personalizzare. Invia nome, ruolo e 3-4 righe di bio e le sostituisco subito.
                  </div>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </section>

      <section id="reti" className="bg-[#292522] text-[#FFFCF8] py-20 lg:py-28">
        <div className="container-vv grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="eyebrow text-[#FF6100]">Reti e collaborazioni</div>
            <h2 className="mt-3 font-display font-medium text-4xl sm:text-5xl">Insieme si va più lontano.</h2>
            <p className="mt-4 text-[#FFFCF8]/70 text-lg max-w-xl">
              Costruiamo relazioni con scuole, enti pubblici, associazioni, professionisti e realtà del Terzo Settore. Le reti sono l'ossatura del nostro modo di lavorare.
            </p>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            {[HeartHandshake, GraduationCap, Scale, Trees, Sparkles, Users].map((Icon, i) => (
              <div key={i} className="rounded-2xl bg-[#FFFCF8]/5 border border-[#FFFCF8]/10 px-5 py-4 flex items-center gap-3">
                <Icon className="h-5 w-5 text-[#FF6100]" strokeWidth={1.5} />
                <span className="text-sm">Partner o rete — placeholder</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-vv py-16">
        <div className="rounded-[2rem] bg-[#FFF1E8] p-10 lg:p-14 text-center">
          <h3 className="font-display text-3xl sm:text-4xl font-medium text-[#292522]">Vuoi conoscerci meglio?</h3>
          <p className="mt-3 text-[#292522]/70 max-w-2xl mx-auto">Scrivici, vieni a un evento, o proponi una collaborazione. Le porte sono aperte.</p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/contatti" className="btn-primary">Scrivici <ArrowRight className="h-4 w-4" strokeWidth={1.75} /></Link>
            <Link to="/eventi" className="btn-ghost">Vieni a un evento</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
